module.exports = __webpack_public_path__ + "static/media/cq_editor_testo_centro.3fc19499.svg";